
import EoContainer from '../EoContainer/EoContainer.vue'
import EoImg from '../EoImg/EoImg.vue'
import EoTabs from '../EoTabs/EoTabs.vue'
import EoLogo from '../EoLogo/EoLogo.vue'

export default {
  name: 'EoHero',
  components: {
    EoContainer,
    EoImg,
    EoTabs,
    EoLogo,
  },
  model: {
    prop: 'activeTab',
    event: 'change',
  },
  props: {
    /**
     * Index of the active tab, if any available
     */
    activeTab: {
      type: [String, Number],
      default: 0,
    },
    /**
     * Title
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Subtitle
     */
    subtitle: {
      type: String,
      default: null,
    },
    /**
     * Description
     */
    description: {
      type: String,
      default: null,
    },
    /**
     * Read more link for description
     */
    readMoreUrl: {
      type: String,
      default: null,
    },
    /**
     * Size of the hero: (flat) (tall) (full)
     */
    size: {
      type: String,
      default: 'flat',
      validator: prop => Object.values(['flat', 'tall', 'full']).includes(prop) || prop === undefined || prop === null,
    },
    /**
     * SOON DEPRECATED: hero with a 4/5 ratio on small screens
     */
    tall: {
      type: Boolean,
      default: false,
    },
    /**
     * Image source OR source set (also used as poster when you provide a video)
     */
    image: {
      type: String,
      default: null,
    },
    /**
     * URL of a video OR multiple URls with different file extensions
     */
    video: {
      type: [String, Array],
      default: null,
    },
    /*
     * Loading attribute of image and video: (eager) (lazy)
     */
    loading: {
      type: String,
      validator: prop => ['eager', 'lazy', '', null].includes(prop),
      default: 'eager',
    },
    /**
     * Fix media to one of the corners or sides (n) (ne) (e) (se) (s) (sw) (w) (nw)
     */
    fixedCorner: {
      type: String,
      validator: value => {
        if (value == '') return true
        return ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'].indexOf(value) !== -1
      },
      default: '',
    },
    /**
     * Style: use primary color for the gradient overlay
     */
    gradientColored: {
      type: Boolean,
      default: false,
    },
    /*
     * Style: background color of the hero
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Style: text color inside the hero
     */
    textColor: {
      type: String,
      default: null,
    },
    /*
     * Style: slider color below the active tab (if present)
     */
    tabsSliderColor: {
      type: String,
      default: null,
    },
    /*
     * Brand for the logo
     */
    brand: {
      type: String,
      default: null, 
    },
    /*
     * Size for the logo
     */
    brandSize: {
      type: String,
      default: null,
    },
    /**
     * Animation: reveal hero media after page load
     */
    mediaReveal: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      activeTabModel: null,
      isLoading: true,
      hasTabs: false,
      isMounted: false,
    }
  },
  computed: {
    classes () {
      return {
        'eo-hero': true,
        'is-loading': this.isLoading,
        'is-gradient-colored': this.gradientColored,
        'is-media-reveal': this.mediaReveal,
        'has-tabs': this.hasTabs,
        ['is-size--' + (this.tall ? 'tall' : this.size)]: !!this.tall || !!this.size,
        ['is-fixed-' + this.fixedCorner]: !!this.fixedCorner,
        ['color--' + this.color]: !!this.color,
        ['text--' + this.textColor]: !!this.textColor,
      }
    },
    videoSources () {
      if (!this.video) return null
      return Array.isArray(this.video) ? this.video : [this.video]
    },
  },
  watch: {
    activeTab: {
      handler: 'setActiveTabModel',
      immediate: true,
    },
  },
  created () {
    this.hasTabs = !!this.$slots.tabs && !!this.$slots.tabs.length
  },
  mounted () {
    this.isMounted = true
    if (this.video) this.isLoading = false // disable lazy loading blur for video
  },
  methods: {
    setActiveTabModel (newIndex) {
      if (newIndex === this.activeTabModel) { return }
      this.activeTabModel = newIndex
    },
    getFileExtension (filename) {
      return filename.substr(filename.lastIndexOf('.') + 1)
    },
  },
}
